// Money arrives as integer cents (see the build plan: money as integers only).
// money(517000) → "$5,170", money(43083) → "$430.83", money(-2000) → "-$20"
export function money(cents) {
	const n = (Number(cents) || 0) / 100
	const abs = Math.abs(n)
	const opts = Number.isInteger(abs) ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }
	return (n < 0 ? '-' : '') + '$' + abs.toLocaleString('en-US', opts)
}

// signed(395000) → "+$3,950", signed(-2000) → "-$20"
export function signed(cents) {
	return (Number(cents) > 0 ? '+' : '') + money(cents)
}
